import { AccountingService, FormattedInvoiceAppointmentResponse } from '@accounting/core/accounting/accounting.service';
import { InvoiceService } from '@accounting/core/accounting/invoice-service/invoice.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, NgForm } from '@angular/forms';
import { UpdateInvoiceAppointmentRequest } from '@gandalf/model/update-invoice-appointment-request';
import { BaseComponent } from '@shared/component/base.component';
import { TABLE_DATE_FORMATS } from '@shared/constants/date-format.constants';
import { SortSettingsModel } from '@syncfusion/ej2-grids';
import { GandalfFormBuilder } from 'gandalf';
import { Subject, throwError } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';

@Component({
	selector: 'pms-appointment-select',
	templateUrl: './appointment-select.component.html',
	styles: [],
	standalone: false,
})
export class AppointmentSelectComponent extends BaseComponent implements OnInit {

	@Input()
	patientId: number;

	@Input()
	invoiceId: number;

	@Output()
	closeModal = new EventEmitter();

	@ViewChild('templateForm')
	templateForm: NgForm;

	isSearchingOrSubmitting = false;
	appointmentsList: FormattedInvoiceAppointmentResponse[];
	appointmentsTableDateFormat = TABLE_DATE_FORMATS.MM_DD_YYYY_H_MM_A;
	unsubscribe$ = new Subject<void>();
	updateInvoiceAppointmentRequest: UpdateInvoiceAppointmentRequest;
	componentForm: UntypedFormGroup;
	sortOptions: SortSettingsModel = {
		columns: [
			{field: 'startDate', direction: 'Descending'},
		],
	};

	constructor(
		private invoiceService: InvoiceService,
		private accountingService: AccountingService,
		private gandalfFormBuilder: GandalfFormBuilder,
	) {
		super();
	}

	ngOnInit() {
		this.getAppointments();
		this.updateInvoiceAppointmentRequest = this.prepareInitialRequest();
		this.componentForm = this.gandalfFormBuilder.group(this.updateInvoiceAppointmentRequest);
	}

	prepareInitialRequest(): UpdateInvoiceAppointmentRequest {
		const request = new UpdateInvoiceAppointmentRequest();
		request.invoiceId = this.invoiceId;
		return request;
	}

	submitForm(event) {
		this.componentForm.get('appointmentId').setValue(event.data.appointmentId);
		this.templateForm.onSubmit(event);
	}

	getAppointments() {
		this.isSearchingOrSubmitting = true;
		this.accountingService.findActivePatientAppointments(this.patientId).pipe(takeUntil(this.unsubscribe$)).subscribe((appointments) => {
			this.appointmentsList = appointments;
			this.isSearchingOrSubmitting = false;
		});
	}

	updateInvoiceAppointment() {
		if (this.componentForm.invalid) {
			return;
		}

		this.isSearchingOrSubmitting = true;
		const request = this.componentForm.value as UpdateInvoiceAppointmentRequest;
		this.accountingService.changeInvoiceAppointment(request).pipe(
			catchError((error) => {
				this.isSearchingOrSubmitting = false;
				return throwError(() => error);
			}),
		).subscribe(() => {
			this.isSearchingOrSubmitting = false;
			this.invoiceService.refreshInvoice(this.invoiceId);
			this.closeModal.emit();
		});
	}

}
